exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".main,.homeSponsor{padding:10px;margin-top:0px;margin-bottom:50px}.main h1,.homeSponsor h1{color:#000000;font-size:24pt;font-weight:700}.main small,.homeSponsor small{color:#000000}.homeSponsor{margin:50px}.homeSponsor a{font-size:15pt;color:#337ab7}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/Containers/HomeElements/HomeSponsor.scss
// module id = 1058
// module chunks = 0